import React from "react";
import Header from "../components/Header/Header";
import Swiper from "../components/Swiper/Swiper";
import ServiceCategory from "../components/Index/ServiceCategory";
import BusinessCoverage from "../components/Index/BusinessCoverage";
import Qualfication from "../components/Index/Qualfication";
import Partner from "../components/Index/Partner";
import ProjictCoverage from "../components/Index/ProjictCoverage";
import Footer from "../components/Footer/Footer";
import IndexBand from "../components/Index/IndexBand";
import BackToTop from "../components/BackToTop/BackToTop";

class Index extends React.Component {
  render() {
    return (
      <div className="index">
        {/* 页头 */}
        <Header pageName="index" />
        {/* 轮播图 */}
        <Swiper />
        {/* 服务范畴 */}
        <ServiceCategory />

        {/* 业务覆盖 */}
        <BusinessCoverage />

        {/* 资质证书 */}
        <Qualfication />

        {/* 中部banner */}
        <IndexBand />

        {/* 合作伙伴 */}
        <Partner />

        {/* 项目覆盖 */}
        <ProjictCoverage />

        {/* 页脚 */}
        <Footer />

        {/* 回到顶部 */}
        <BackToTop />
      </div>
    )
  }
}

export default Index
